import { ActionIcon, Menu } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { useOrgs } from "~/hooks";
import { changeLanguage } from "~/i18n";

const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "pt-BR", label: "Português (Brasil)", flag: "🇧🇷" },
] as const;

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const { isJbsBrazil } = useOrgs();

  const currentLanguage =
    SUPPORTED_LANGUAGES.find((lang) => lang.code === i18n.language) ||
    SUPPORTED_LANGUAGES[0];

  if (!isJbsBrazil()) {
    return null;
  }

  return (
    <Menu>
      <Menu.Target>
        <ActionIcon variant="subtle" size="md">
          <span style={{ fontSize: 20 }}>{currentLanguage.flag}</span>
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        {SUPPORTED_LANGUAGES.map((lang) => (
          <Menu.Item
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            leftSection={<span style={{ fontSize: 16 }}>{lang.flag}</span>}
            style={{
              fontWeight: lang.code === i18n.language ? "bold" : "normal",
            }}
          >
            {lang.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};

export default LanguageSwitcher;
